// import $store from '@/store.js'

export const loginConfig = {
  urlCom: 'https://channel.tvunetworks.com/',
  urlCn: 'https://channel.tvunetworks.cn/',
  devurl: 'https://channel-dev.tvunetworks.com/channel/',
  activityCode: '622474',
  serverName: 'TVU Channel',
  loginUrlCom: 'https://userservice.tvunetworks.com/common/login/#/signIn',
  loginUrlCn: 'https://userservice.tvunetworks.cn/common/login/#/signIn',
  loginUrldev: 'https://cc-ms-dev.tvunetworks.com/common/login'
  // https://10.12.22.24:8081/#/signIn
  // https://userservice.tvunetworks.com/common/login/#/signIn
}

export function creatAccount () {
  if (window.messenger) {
    let url = ''
    const host = window.location.host
    if (host.includes('channel-dev.tvunetworks.com')) {
      url = loginConfig.devurl
    } else {
      url = window.location.host.includes('cn') ? loginConfig.urlCn : loginConfig.urlCom
    }
    const obj = {
      type: 'signIn',
      data: {
        url: url,
        lang: localStorage.getItem('lang') || navigator.language || navigator.userLanguage,
        activityCode: loginConfig.activityCode,
        serverName: loginConfig.serverName
      }
    }
    window.messenger.targets.loginIframe.send(JSON.stringify(obj))
    document.getElementById('loginIframe').style.display = 'block'
  }
}

export default {
  loginConfig
}
